import React from 'react';
import { useLanguage, Language } from '@/contexts/LanguageContext';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';

interface LanguageSelectorProps {
  size?: 'default' | 'sm' | 'lg' | 'icon';
  variant?: 'default' | 'destructive' | 'outline' | 'secondary' | 'ghost' | 'link';
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({ 
  size = 'default',
  variant = 'outline'
}) => {
  const { language, setLanguage } = useLanguage();

  const languageNames: Record<Language, string> = {
    he: 'עברית',
    en: 'English',
    fr: 'Français',
    es: 'Español'
  };

  const languageFlags: Record<Language, string> = {
    he: '🇮🇱',
    en: '🇬🇧',
    fr: '🇫🇷',
    es: '🇪🇸'
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant={variant} size={size} className="px-2">
          <span className="mr-1">{languageFlags[language]}</span>
          <span className="hidden md:inline">{languageNames[language]}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {Object.entries(languageNames).map(([code, name]) => (
          <DropdownMenuItem 
            key={code} 
            onClick={() => setLanguage(code as Language)}
            className={language === code ? 'bg-synagogue-blue/10 font-semibold' : ''}
          >
            <span className="mr-2">{languageFlags[code as Language]}</span>
            {name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSelector; 